import { Col } from '../../components/custom';

export default function AnalyzeFeedback()
{
    return (
        <Col id='analyzeFeedback' className='perspectives'>
            <Col className='banner'>
                <span className='title'>Analyzing Customer Feedback on Forums & Review Sites</span>
                <span className='desc'>Uncover hidden insights by listening where customers speak most freely.</span>
            </Col>
            <Col className='section'>
                <span className='title'>The Challenge</span>
                <span className='desc bold'>Your customers are talking — just not always to you.</span>
                <span className='descsmall'>While surveys and feedback forms offer structured insights, some of the most honest, unfiltered opinions live on external forums, Reddit threads, product reviews, and app store ratings. Traditional customer feedback programs often miss this goldmine of insight, leaving critical experience gaps unaddressed.</span>
            </Col>
            <Col className='section'>
                <span className='title'>Our Philosophy</span>
                <span className='desc bold'>Go where the conversation is. Decode the emotion. Surface what matters.</span>
                <span className='descsmall'>To truly understand customer sentiment, we believe in listening beyond the brand-owned channels. Forums and review sites capture the raw, emotional voice of the customer — and analyzing these spaces reveals patterns that formal feedback rarely surfaces.</span>
            </Col>
            <Col className='section'>
                <span className='title'>The Intelligence Framework</span>
                <span className='desc'>A sentiment-first strategy for external feedback mining:</span>
                <ul>
                    <li className='descsmall'>
                        <strong>Platform Monitoring</strong>
                        <ul>
                            <li className='descsmall'>Identify key review and discussion platforms relevant to your audience (e.g., G2, Reddit, App Store, Trustpilot).</li>
                            <li className='descsmall'>Continuously collect publicly available feedback and discussion threads.</li>
                        </ul>
                    </li>
                    <li className='descsmall'>
                        <strong>Sentiment & Emotion Analysis</strong>
                        <ul>
                            <li className='descsmall'>Use advanced NLP to detect tone, satisfaction levels, frustration points, and emerging praise.</li>
                            <li className='descsmall'>Categorize insights into themes like usability, value, support experience, etc.</li>
                        </ul>
                    </li>
                    <li className='descsmall'>
                        <strong>Competitor Benchmarking</strong>
                        <ul>
                            <li className='descsmall'>Compare sentiment and feature mentions with peer or competitor brands.</li>
                            <li className='descsmall'>Understand what others are doing right — or wrong — in the same space.</li>
                        </ul>
                    </li>
                    <li className='descsmall'>
                        <strong>Topic Clustering & Trend Detection</strong>
                        <ul>
                            <li className='descsmall'>Group conversations into core experience buckets (onboarding, pricing, bugs, customer service).</li>
                            <li className='descsmall'>Highlight recurring issues or praise that deserve visibility or action.</li>
                        </ul>
                    </li>
                </ul>
            </Col>
            <Col className='section'>
                <span className='title'>What This Enables</span>
                <ul>
                    <li className='descsmall'><strong>360° Customer Understanding</strong> — Extend insights beyond surveys to see the full picture.</li>
                    <li className='descsmall'><strong>Product & CX Alignment </strong> — Feed real-world feedback into product roadmaps and service design.</li>
                    <li className='descsmall'><strong>Competitive Advantage</strong> — Spot emerging customer needs before your competitors do.</li>
                    <li className='descsmall'><strong>Stronger Brand Perception</strong> — Proactively address friction points where customers are publicly speaking.</li>
                </ul>
            </Col>
            <Col className='section'>
                <span className='title'>The Takeaway</span>
                <span className='desc bold'>Your best product feedback isn't in your inbox — it's on the internet.</span>
                <span className='descsmall'>With the right listening tools and intelligence strategy, organizations can transform unstructured public feedback into strategic direction and customer loyalty.</span>
            </Col>
        </Col>
    )
}